import StickyElementSentinel from './sentinel';

// Scrollable is the expanded region that scrolls away: the same stuck-detection
// as <sticky.sentinel>, but wrapped around real content instead of a zero-height
// marker. The observer hands off to the pinned bar once the region's bottom
// scrolls past the handoff line, so the two never overlap. The region never
// morphs, so the observer can't feed back into the toggle.
export default class StickyElementScrollable extends StickyElementSentinel {}
